import store from "../store";
import axiosUrl from "./axios.service";
import axios from "axios";

const API_URL = axiosUrl.getAxiosUrl();
const AI_ASSISTANT_PROCESSOR_URL =
  process.env.VUE_APP_AI_ASSISTANT_PROCESSOR_URL;

class AIAssistantService {
  getAIAssistantAccessToken() {
    return axios
      .post(API_URL + "/users/getAIAssistantAccessToken")
      .then((response) => {
        if (response.status === 200) {
          store.commit("chat/setAIAssistantAccessToken", response.data);
        }
      });
    // TODO: catch
  }

  async processPrompt(conversation, locale, noResultsText) {
    const payload = conversation.map((message) => ({
      role: message.author.id,
      content: message.text,
    }));
    return await axios
      .post(
        AI_ASSISTANT_PROCESSOR_URL + "/AIAssistantProcessor/processPrompt",
        {
          messages: payload,
          locale: locale,
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.chat.aiAssistantAccessToken.accessToken}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          store.commit("chat/setTypingUsers", []);
          if (response.data)
            store.commit("chat/addMessageToChat", response.data);
          else {
            store.commit("chat/addMessageToChat", { content: noResultsText});
          }
        }
      })
      // TODO
      .catch((error) => console.log(error.message));
  }
}

export default new AIAssistantService();
